import { appRoutes } from '@/router/routes';
import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URI || 'http://localhost:5005/api/';

const axiosClient = axios.create({
    baseURL: `${apiUrl}`,
    headers: {
        'content-type': 'application/json',
    },
});

axiosClient.interceptors.request.use(async (config) => {
    const customHeaders = {
        apitoken: '',
    };

    const token = localStorage.getItem('token');
    if (token) {
        customHeaders.apitoken = token;
    }

    return {
        ...config,
        headers: {
            ...customHeaders, // auto attach token
            ...config.headers, // but you can override for some requests
        },
    };
});

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error(error.response, 'interceptors Error');
        if (error.response.status === 401 && window.location.pathname !== `/${appRoutes.AUTH.LOGIN}`) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        } else {
            throw error;
        }
    },
);

export default axiosClient;
